import React, { useState } from "react"
import DownArrow from "../../icons/DownTriangleGrey.svg"
import CloseModalIcon from "../../icons/close_modal.svg"
import {
  setDataQualityConfigModal,
  setBusinessQualityConfigModal,
  resetAiRulesModalDataDescription,
} from "./DataQualitySlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import BgImage from "../../assets/images/galaxy_bg.png"

interface Tab {
  title: string
  content: React.ReactNode
}

interface TabMenuProps {
  tabs: Tab[]
  defaultActiveTab?: number
}

const TabMenu = ({ tabs, defaultActiveTab = 0 }: TabMenuProps) => {
  const [activeTab, setActiveTab] = useState<number>(defaultActiveTab)
  const dispatch = useAppDispatch()

  const handleCloseDialog = () => {
    dispatch(setDataQualityConfigModal(false))
    dispatch(setBusinessQualityConfigModal(false))
  }

  return (
    <div className="w-full mx-auto">
      <div className="relative flex h-[68px] gap-4 items-center rounded-t-md px-12 relative">
        <div
          style={{ backgroundImage: `url(${BgImage})` }}
          className={`absolute inset-0 bg-center bg-cover opacity-20 rounded-t`}
        />

        <div className="relative flex w-full items-center gap-4">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`flex flex-col py-[2px] px-3 rounded-md items-center focus:outline-none ${
                activeTab === index
                  ? "bg-dpTheme-main text-grey-50"
                  : "text-base"
              }`}
            >
              {tab.title}
            </button>
          ))}
        </div>

        <button onClick={handleCloseDialog} className="absolute top-3 right-4">
          <img src={CloseModalIcon} alt="" />
        </button>
      </div>

      <div className="">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`${
              activeTab === index ? "block" : "hidden"
            } text-gray-700`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  )
}

const Configuration = () => {
  const modalData = useAppSelector(
    (state) => state.dataQuality.aiRulesModalData.configuration,
  )
  const dispatch = useAppDispatch()

  const [description, setDescription] = useState(modalData.description)

  const handleOnChange = (e: any) => {
    setDescription(e.target.value)
  }

  const handleOnSaveClick = () => {
    dispatch(resetAiRulesModalDataDescription(description))
    dispatch(setDataQualityConfigModal(false))
  }

  return (
    <div className="flex flex-col gap-4 px-10 py-4">
      <div
        className="rounded w-fit self-end  flex items-center justify-center py-1 px-2 font-bold text-[10px]"
        style={{
          background:
            "linear-gradient(90deg, #67F0FF 0%, #CCC0DD 50%, #FFA0BB 100%)",
        }}
      >
        <p>GenAI Insight on Suggestion</p>
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Dataset Applied</label>
          <input
            type="text"
            placeholder="Sales"
            value={modalData?.dataset}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full text-customGrey-450"
            disabled
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Check Description</label>
          <textarea
            value={description}
            onChange={handleOnChange}
            className="rounded text-base border border-customGrey-400 px-4 py-2 outline-none w-full h-[150px] resize-none"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Columns Applied</label>
          <div className="flex items-center gap-4">
            <div className="flex grow gap-1 border border-customGrey-400 rounded px-4">
              <input
                className="grow rounded h-10 outline-none"
                type="text"
                value={modalData.columnsToApply}
                disabled
              />
              <img src={DownArrow} alt="" />
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Date Added</label>
          <input
            type="text"
            placeholder="09-08-2024"
            value={"09-08-2024"}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full text-customGrey-450"
            disabled
          />
        </div>
        {/* <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Threshold</label>
          <input
            type="text"
            placeholder="Threshold"
            value={"75%"}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
          />
        </div> */}
        <div className="flex justify-end">
          <button
            onClick={handleOnSaveClick}
            className="mt-2 w-[103px] h-7 bg-dpTheme-main text-white rounded-md cursor-pointer text-xs transition duration-300 ease-in-out transform hover:bg-dpTheme-main hover:scale-105 hover:shadow-lg active:scale-95 active:bg-grey-50 active:shadow-inner focus:outline-none"
          >
            Save
          </button>
        </div>
      </div>
      <hr className="mb-5 mt-2" />
    </div>
  )
}

interface IDeviation {
  deviation: string
  percentageChange: {
    from: number | null
    to: number | null
  }
}

const Conditions = () => {
  const [addDeviation, setAddDeviation] = useState(false)
  const [deviation, setDeviation] = useState<IDeviation>({
    deviation: "",
    percentageChange: {
      from: null,
      to: null,
    },
  })
  const [deviationData, setDeviationData] = useState<IDeviation[]>([
    {
      deviation: "Sales Volume",
      percentageChange: {
        from: 10,
        to: 12,
      },
    },
  ])

  const handleAddonClick = () => {
    setAddDeviation(true)
    console.log(deviation)
    deviation.deviation &&
      deviation.percentageChange.from &&
      deviation.percentageChange.to &&
      setDeviationData([...deviationData, deviation])
    setDeviation({
      deviation: "",
      percentageChange: {
        from: null,
        to: null,
      },
    })
  }

  const handleDeviationChange = ({ event, ind }: any) => {
    const value = event.target.value

    setDeviation((prev) => {
      return {
        ...prev,
        deviation: ind === 0 ? value : prev.deviation,
        percentageChange: {
          ...prev.percentageChange,
          from: ind === 1 ? value : prev.percentageChange.from,
          to: ind === 2 ? value : prev.percentageChange.to,
        },
      }
    })

    console.log(value)
  }

  return (
    <div className="flex flex-col px-10 py-4 min-h-[600px] justify-between">
      <div className="flex flex-col">
        <div
          className="rounded w-fit self-end  flex items-center justify-center py-1 px-2 font-bold text-[10px]"
          style={{
            background:
              "linear-gradient(90deg, #67F0FF 0%, #CCC0DD 50%, #FFA0BB 100%)",
          }}
        >
          <p>GenAI Insight on Suggestion</p>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex gap-9">
            <div className="flex flex-col gap-[10px]">
              {/* top */}
              <div className="flex gap-4">
                <label className="font-bold text-base w-[150px]">
                  MoM Deviation
                </label>
                <label className="font-bold text-base">% Change</label>
              </div>

              {/* bottom */}
              <div className="flex gap-2">
                <div className="flex flex-col gap-2">
                  {deviationData.map((item, index) => (
                    <div key={index} className="flex ">
                      <input
                        type="text"
                        placeholder="When"
                        value={item.deviation}
                        className="h-[40px] max-w-[150px] mr-4 rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                      />
                      <div className="flex items-center gap-3">
                        <input
                          type="text"
                          placeholder=""
                          value={item.percentageChange.from || 0}
                          className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                        />
                        <label className="font-bold text-base">To</label>
                        <input
                          type="text"
                          placeholder=""
                          value={item.percentageChange.to || 0}
                          className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                        />
                      </div>
                    </div>
                  ))}

                  {addDeviation && (
                    <div className="flex ">
                      <input
                        type="text"
                        placeholder="When"
                        onChange={(e) =>
                          handleDeviationChange({ event: e, ind: 0 })
                        }
                        value={deviation.deviation}
                        className="h-[40px] max-w-[150px] mr-4 rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                      />
                      <div className="flex items-center gap-3">
                        <input
                          type="text"
                          placeholder="from"
                          onChange={(e) =>
                            handleDeviationChange({ event: e, ind: 1 })
                          }
                          value={deviation.percentageChange.from ?? ""}
                          className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                        />
                        <label className="font-bold text-base">To</label>
                        <input
                          type="text"
                          placeholder="to"
                          onChange={(e) =>
                            handleDeviationChange({ event: e, ind: 2 })
                          }
                          value={deviation.percentageChange.to ?? ""}
                          className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex items-end">
                  <button
                    onClick={handleAddonClick}
                    style={{ minWidth: "40px" }}
                    className="outline-none flex items-center justify-center h-[40px] rounded bg-customGrey-200 text-white font-extrabold text-3xl "
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="font-bold text-base">Strategy on Failure</label>
            <div className="flex grow gap-1 border border-customGrey-400 rounded px-4">
              <input
                className="grow rounded h-10 outline-none"
                type="text"
                value={"Exit"}
              />
              <img src={DownArrow} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex justify-end">
          <button
            // onClick={handleOnSaveClick}
            className="mt-2 w-[103px] h-7 bg-dpTheme-main text-white rounded-md cursor-pointer text-xs transition duration-300 ease-in-out transform hover:bg-dpTheme-main hover:scale-105 hover:shadow-lg active:scale-95 active:bg-grey-50 active:shadow-inner focus:outline-none"
          >
            Save
          </button>
        </div>
        <hr className="mb-5 mt-2" />
      </div>
    </div>
  )
}

const Implementations = () => {
  return (
    <div className="flex flex-col gap-4 px-10 py-4 min-h-[600px] justify-between">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Period</label>
          <div className="flex border border-customGrey-400 rounded px-4">
            <input
              className="grow rounded h-10 outline-none"
              type="text"
              value={"Every Monthly Refresh"}
            />
            <img src={DownArrow} alt="" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Report</label>
          <div className="flex items-center border border-customGrey-400 rounded px-4 gap-3">
            <input
              className="grow rounded h-10 outline-none"
              type="email"
              value={"Admin@email.com"}
            />
            <button
              style={{ minWidth: "22px" }}
              className="flex items-center justify-center h-[22px] rounded bg-customGrey-200 text-white font-extrabold text-[14px] pb-1"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex justify-end">
          <button
            // onClick={handleOnSaveClick}
            className="mt-2 w-[103px] h-7 bg-dpTheme-main text-white rounded-md cursor-pointer text-xs transition duration-300 ease-in-out transform hover:bg-dpTheme-main hover:scale-105 hover:shadow-lg active:scale-95 active:bg-grey-50 active:shadow-inner focus:outline-none"
          >
            Save
          </button>
        </div>
        <hr className="mb-5 mt-2" />
      </div>
    </div>
  )
}

export default function AiConfig() {
  const tabs: Tab[] = [
    {
      title: "Configuration",
      content: <Configuration />,
    },
    {
      title: "Conditions",
      content: <Conditions />,
    },
    {
      title: "Implementations",
      content: <Implementations />,
    },
  ]

  return (
    <div className="flex flex-col gap-4 bg-white rounded-md">
      <TabMenu tabs={tabs} defaultActiveTab={0} />
    </div>
  )
}
